import React, { useState } from 'react';
import {
  Box, Button, Checkbox, FormControlLabel, Typography,
} from '@mui/material';
import { FormattedMessage } from 'react-intl';
import { DigitalQuestion } from '../../../redux/types';

type Props = {
  question?: DigitalQuestion;
  onSaveQuestionSetting: (modifiedQuestion: DigitalQuestion) => void;
};

const AuswertungQuestionSettingDialog: React.FC<Props> = ({
  question,
  onSaveQuestionSetting,
}: Props) => {
  const [hideFromAggregation, setHideFromAggregation] = useState<boolean|undefined>(
    question?.hideAggregation,
  );

  const onhideAggregationChange = (
    event: React.SyntheticEvent<Element, Event>, checked: boolean,
  ) => {
    setHideFromAggregation(checked);
  };

  const saveClickHandler = () => {
    if (!question) {
      return;
    }
    const newQuestion: DigitalQuestion = {
      ...question,
      hideAggregation: hideFromAggregation,
    };
    onSaveQuestionSetting(newQuestion);
  };

  if (!question) {
    return null;
  }

  return (
    <Box sx={{ m: 2 }}>
      <Typography variant="h5">Settings</Typography>
      <Box sx={{ my: 2 }}>
        <FormControlLabel
          label={<FormattedMessage id="questionEditor.hideAggregation" />}
          control={<Checkbox />}
          onChange={onhideAggregationChange}
          checked={hideFromAggregation || false}
        />
      </Box>
      <Box sx={{ mt: 2 }} justifyContent="flex-end" display="flex">
        <Button onClick={saveClickHandler} variant="contained">Save</Button>
      </Box>
    </Box>
  );
};

export default AuswertungQuestionSettingDialog;
